import { render } from "./SwiperComponents.vue?vue&type=template&id=abdf2f5a&scoped=true"
import script from "./SwiperComponents.vue?vue&type=script&lang=js"
export * from "./SwiperComponents.vue?vue&type=script&lang=js"

import "./SwiperComponents.vue?vue&type=style&index=0&id=abdf2f5a&lang=css"
import "./SwiperComponents.vue?vue&type=style&index=1&id=abdf2f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abdf2f5a"]])

export default __exports__